import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IGetDetailParams } from '../types/IGetDetailParams';

export class GetDetailRequest<TDetailResult extends IResult> extends Request<IGetDetailParams, TDetailResult> {
  constructor(method: string, id: string) {
    super(method, { id: id });
  }
}
